import { Box, Stack } from "@mui/material";
import { EfficiencyMetricsCards } from "./EfficiencyMetricsCards";

export default function EfficiencyMetrics() {
  return (
    <Box>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          <EfficiencyMetricsCards
            title="CPC"
            value="31,605"
            total="127,052"
            rr="51.8%"
            pr="45,877"
            rrColor="success"
          />

          <EfficiencyMetricsCards
            title="CAC"
            value="13.72%"
            total="13.14%"
            rr="104.4%"
            pr="13.72%"
            rrColor="warning"
          />
        </Stack>
      </Stack>
    </Box>
  );
}
